import React from 'react';
import { isNull } from 'lodash';
import {
  openNewWindow,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  setPhoneFormat,
  setNumberWithComma,
} from '../../../../lib/common';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import InputForm from '../../../../components/form/InputForm';
import Anchor from '../../../../components/link/Anchor';
import { formRequiredRules } from '../../../../lib/formRules';
import SelectForm from '../../../../components/form/SelectForm';
import SendMessageService from '../../../../containers/app/common/SendMessageService';
import { REX_NUMBER } from '../../../../lib/rex';
import {
  MAXIMUM_NUMBER_OF_AMOUNT,
  MINIMUM_NUMBER_OF_AMOUNT,
  POINT_LOG_TYPE,
  POINT_LOG_TYPE_SELECT_LIST,
} from '../../../../constants/service/app/pointConstants';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { ACCOUNT_USER_DETAIL_TAB_KEY } from '../../../../constants/service/app/accountUserConstants';
import { AMONDZ_MEMBER_TYPE } from '../../../../constants/service/common/utilConstants';
import { REQUIRED_MSG } from '../../../../constants/service/common/formRulesConstants';

/**
 *  유저 리스트 컬럼
 */
const columns = (data) => {
  const { pointCauseSelectList, setData, list, selectedUserInfoList, form, initCause } = data;

  return [
    {
      dataIndex: 'userId',
      title: <TableColumnTitle title={'회원 번호'} />,
      width: setColumnWidth(list, 'userId'),
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, value) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.POINT_INFO}`,
            )
          }
        />
      ),
    },
    {
      dataIndex: 'name',
      title: <TableColumnTitle title={'이름'} />,
      Header: '이름',
      render: (value) => setDash(value),
    },
    {
      dataIndex: 'cellPhone',
      title: <TableColumnTitle title={'휴대전화 번호'} />,
      Header: '휴대전화 번호',
      render: (value, record) => (
        <SendMessageService
          text={setPhoneFormat(value)}
          memberType={AMONDZ_MEMBER_TYPE.USER}
          targetId={record.userId}
        />
      ),
    },
    {
      dataIndex: 'pointAmount',
      title: <TableColumnTitle title={'사용 가능한 포인트'} />,
      render: (value) => setNumberWithComma(value),
    },
    {
      dataIndex: 'usedPointAmount',
      title: <TableColumnTitle title={'사용한 포인트'} />,
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'내역 종류'} />,
      Header: '내역 종류',
      render: (value, record, index) => {
        return (
          <SelectForm
            form={form}
            name={`type_${record.id}`}
            list={POINT_LOG_TYPE_SELECT_LIST}
            isTable={true}
            placeholder={'선택'}
            rules={[
              formRequiredRules(true, REQUIRED_MSG, false),
              {
                validator: (rule, value, cb) => {
                  if (value < POINT_LOG_TYPE.SAVE || value > POINT_LOG_TYPE.USE) {
                    cb('필수 값입니다.');
                  }
                  cb();
                },
              },
            ]}
            onChange={(value) => {
              setData({
                path: ['selectedUserInfoList', index, 'type'],
                value,
              });
              initCause({
                id: record.id,
              });
            }}
          />
        );
      },
    },
    {
      title: <TableColumnTitle title={'적립/사용처'} />,
      render: (value, record, index) => {
        return (
          <SelectForm
            form={form}
            name={`pointCauseId_${record.id}`}
            list={
              selectedUserInfoList[index].type === POINT_LOG_TYPE.SAVE
                ? pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.SAVE)
                : pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.USE)
            }
            isTable={true}
            placeholder={'선택'}
            disabled={isNull(selectedUserInfoList[index].type)}
            rules={[
              formRequiredRules(true, REQUIRED_MSG, false),
              {
                validator: (rule, value, cb) => {
                  if (isNull(value)) {
                    cb('필수 값입니다.');
                  }
                  cb();
                },
              },
            ]}
            onChange={(value) => {
              setData({
                path: ['selectedUserInfoList', index, 'pointCauseId'],
                value,
              });
            }}
          />
        );
      },
    },
    {
      title: <TableColumnTitle title={'액수'} />,
      render: (value, record, index) => {
        return (
          <InputForm
            className="amount"
            type="number"
            form={form}
            name={`amount_${record.id}`}
            min={MINIMUM_NUMBER_OF_AMOUNT}
            max={MAXIMUM_NUMBER_OF_AMOUNT}
            placeholder={'0'}
            rules={[
              { pattern: REX_NUMBER, message: '필수 사항 입니다.' },
              {
                validator: (rule, value, cb) => {
                  if (!value) {
                    cb('액수는 1원 이상입니다.');
                  }
                  cb();
                },
              },
            ]}
            onChange={(value) => {
              setData({
                path: ['selectedUserInfoList', index, 'amount'],
                value,
              });
            }}
          />
        );
      },
    },
  ];
};

export default columns;
